import { render, staticRenderFns } from "./OfferCardTargeting.vue?vue&type=template&id=1fae9590&"
import script from "./OfferCardTargeting.vue?vue&type=script&lang=ts&"
export * from "./OfferCardTargeting.vue?vue&type=script&lang=ts&"
import style0 from "./OfferCardTargeting.vue?vue&type=style&index=0&id=1fae9590&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports